import { render, staticRenderFns } from "./formal.vue?vue&type=template&id=4477742e&"
import script from "./formal.vue?vue&type=script&lang=js&"
export * from "./formal.vue?vue&type=script&lang=js&"
import style0 from "./formal.vue?vue&type=style&index=0&id=4477742e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports